/**
 * Currency formatting utilities
 */

/**
 * Format a number as currency with commas and 2 decimal places
 * @param {number} amount - The amount to format
 * @param {string} symbol - Currency symbol (default: '$')
 * @returns {string} Formatted currency string (e.g., $1,234.56)
 */
export const formatCurrency = (amount, symbol = '$') => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return `${symbol}0.00`;
  }
  
  const absAmount = Math.abs(amount);
  const formatted = absAmount?.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  
  return `${symbol}${formatted}`;
};

/**
 * Format amount with sign prefix for transactions
 * @param {number} amount - The amount to format
 * @param {string} symbol - Currency symbol (default: '$')
 * @returns {string} Formatted amount with +/- prefix
 */
export const formatAmountWithSign = (amount, symbol = '$') => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return `${symbol}0.00`;
  }
  
  const absAmount = Math.abs(amount);
  const formatted = absAmount?.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  
  const sign = amount >= 0 ? '+' : '-';
  return `${sign}${symbol}${formatted}`;
};

/**
 * Get currency symbol (can be extended for multi-currency support)
 * @returns {string} Currency symbol
 */
export const getCurrencySymbol = () => {
  return '$';
};

/**
 * Format number with commas and exactly 2 decimal places (no currency symbol)
 * @param {number} amount - The amount to format
 * @returns {string} Formatted number string (e.g., 1,234.56)
 */
export const formatNumber = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '0.00';
  }
  
  return amount?.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};